import {
	ChangeDetectionStrategy,
	Component,
	ContentChild,
	Input,
	OnChanges,
	OnDestroy,
	SimpleChanges,
	TemplateRef,
	ViewChild
} from "@angular/core";
import { BpTabLabelComponent } from "@modules/shared/bp-tabs/bp-tab-label/bp-tab-label.component";
import { Subject } from "rxjs";

@Component({
	selector: "bp-tab-item",
	template: "<ng-template><ng-content></ng-content></ng-template>",
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class BpTabItemComponent implements OnChanges, OnDestroy {
	@Input() public label: string;
	@Input() public isActive: boolean;

	@ViewChild(TemplateRef) itemContent: TemplateRef<unknown>;
	@ContentChild(BpTabLabelComponent) public labelComponent: BpTabLabelComponent;

	readonly _stateChanges = new Subject<void>();

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.hasOwnProperty("label") || changes.hasOwnProperty("isActive")) {
			this._stateChanges.next();
		}
	}

	ngOnDestroy(): void {
		this._stateChanges.complete();
	}
}
